import './service-worker-lifecycle.scss';
import { interval } from 'rxjs';
import { Component } from 'vue-property-decorator';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons';

import { ReactiveVue } from '@skinsoft/reactive-vue';

import { Event, serviceWorker$, States } from './register-service-worker';
import { FORCE_UPDATE_SERVICE_WORKER_TOPIC } from '@skinsoft/bus';

const CHECK_FOR_UPDATE_INTERVAL = 60e3;

@Component({
    template: require('./service-worker-lifecycle.html'),
})
export class ServiceWorkerLifecycle extends ReactiveVue {
    public bullhornIcon = faBullhorn;

    public updateInProgress = false;
    public updateFound = false;
    public serviceWorkerState: States = null as any;

    private registration: ServiceWorkerRegistration;

    public created() {
        this.subscribeTo(serviceWorker$, (event: Event) => {
            if (event.registration) {
                this.registration = event.registration as ServiceWorkerRegistration;
            }

            this.updateFound = event.state === States.UPDATED;
        });
        this.subscribeToBus('check_for_update_topic', () => {
            this.checkForUpdate();
        });
        this.subscribeTo(interval(CHECK_FOR_UPDATE_INTERVAL), () => {
            this.checkForUpdate();
        });
        this.subscribeToBus(FORCE_UPDATE_SERVICE_WORKER_TOPIC, () => {
            this.forceUpdateServiceWorker()
        })
    }

    public update() {
        this.updateInProgress = true;
        // @ts-ignore
        location.reload(true);
    }

    private checkForUpdate() {
        if (!this.registration) {
            return;
        }

        this.registration.update();
    }

    private forceUpdateServiceWorker() {
        if(this.registration) {
            if(this.registration.waiting) {
                this.registration.waiting.postMessage({ action: 'skipWaiting' })
            }
        }
    }
}
